import { useEffect, useState } from 'react';

/**
 * <Toast message="..." type="success|error" onClose={() => {}} />
 * Auto-dismisses after 3 seconds.
 */
export default function Toast({ message, type = 'success', onClose }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Trigger enter animation
    const show = setTimeout(() => setVisible(true), 10);
    // Auto-dismiss after 3 s
    const hide = setTimeout(() => {
      setVisible(false);
      setTimeout(onClose, 300);
    }, 3000);
    return () => { clearTimeout(show); clearTimeout(hide); };
  }, []);

  const bg      = type === 'success' ? '#16A34A' : '#DC2626';
  const icon    = type === 'success' ? '✓' : '✕';

  return (
    <div style={{
      position:       'fixed',
      bottom:         24,
      right:          24,
      zIndex:         9999,
      display:        'flex',
      alignItems:     'center',
      gap:            10,
      background:     bg,
      color:          '#FFF',
      padding:        '12px 18px',
      borderRadius:   10,
      fontSize:       '0.875rem',
      fontWeight:     500,
      boxShadow:      '0 8px 24px rgba(0,0,0,0.18)',
      maxWidth:       360,
      transform:      visible ? 'translateY(0)' : 'translateY(80px)',
      opacity:        visible ? 1 : 0,
      transition:     'transform 0.25s ease, opacity 0.25s ease',
    }}>
      <span style={{ fontWeight: 700, fontSize: '1rem' }}>{icon}</span>
      <span>{message}</span>
      <button
        onClick={() => { setVisible(false); setTimeout(onClose, 300); }}
        style={{ marginLeft: 8, background: 'none', border: 'none', color: '#FFF', cursor: 'pointer', fontSize: '1rem', lineHeight: 1, opacity: 0.8 }}
      >
        ✕
      </button>
    </div>
  );
}
